import { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import fp from 'lodash/fp';
import { messaging } from '@factorin/container.macro';

import { useSelector } from 'Modules/core/redux';

import { messagingActions } from './actions';
import { MessagingQueueTypes, MessagingRootState, ConfirmCloseModalProps, ErrorData } from './types';


export const useHideAction = () => {
    const queue = useSelector<MessagingQueueTypes[]>('messaging');
    const dispatch = useDispatch();
    const hide = useCallback((modalId: number) =>
        dispatch(messagingActions.hideMessage(modalId)), [dispatch]);

    const hideModal = useCallback(
        (modal: MessagingQueueTypes) => {
            if (modal) {
                if (messaging.modalTypes[modal.type].confirmCloseModalType && modal.confirmClose) {
                    dispatch(messagingActions.showModal({
                        type: messaging.modalTypes[modal.type].confirmCloseModalType,
                        props: {
                            onConfirm: confirmModalId => {
                                hide(confirmModalId);
                                hide(modal.id);
                            },
                            onCancel: confirmModalId =>
                                hide(confirmModalId),
                        } as ConfirmCloseModalProps,
                    }));
                } else
                    hide(modal.id);
            }
        },
        [dispatch, hide],
    );
    const hideLastModal = useCallback(() => {
        const lastModal = fp.last(queue.filter(m => m.isModal && m.closeable));
        hideModal(lastModal);
    }, [hideModal, queue]);
    return {
        queue,
        hide,
        hideModal,
        hideLastModal,
    };
};

export const connector = connect(
    ({ messaging: queue }: MessagingRootState) => ({
        queue,
    }),
    {
        hide: messagingActions.hideMessage,
    },
);

export const isInfoError = (error: unknown): boolean =>
    fp.get('response.data.ErrorType', error) === 'Info' ||
    fp.get('response.data.errorType', error) === 'Info';

export const getErrorData = (error: unknown): ErrorData => ({
    title: fp.get('response.data.title', error) ?? fp.getOr(error, 'response.data.Title', error),
    text: fp.get('response.data.details', error) || null,
});
